u.Openable = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */        
        super.createdCallback();

        this._click = (evt) => {
            let parent = evt.target;
            while (parent) {
                if (parent === this) {
                    return;
                }
                parent = parent.parentElement;
            }
            evt.preventDefault();
            this.$close();
        };
        
        this._keyup = (evt) => {
            if (evt.keyCode === 27) {
                this.$close();
            }
        };
    }

    detachedCallback() {
        /**
         * Cleanup element on detachment
         */
        this.$close();
    }
    
    $toggle() {
        /**
         * Toggle the element open and close
         */
        if (this.classList.contains('open')) {
            this.$close();
        } else {
            this.$open();
        }
    }    

    $open() {
        /**
         * Open the element
         */

        document.addEventListener('click', this._click);
        document.addEventListener('keyup', this._keyup);
        document.body.style.overflowY = 'hidden';
        this.classList.add('open');
        this.dispatchEvent(new Event('u-modal-open'));
    }

    $close() {
        /**
         * Close the element
         */

        document.removeEventListener('click', this._click);
        document.removeEventListener('keyup', this._keyup);
        document.body.style.overflowY = 'inherit';
        this.classList.remove('open');
        this.dispatchEvent(new Event('u-modal-close'));
    }
};

u.Modal = class extends u.Openable {
    createdCallback() {
        /**
         * example:
         *
         * <u-modal id="modal-dev-license" class="sb.modal" u-backdrop="static" u-show="true">
         *
         * options:
         *
         *
         * u-backdrop
         *
         * static: disable the background. the user can close the modal only when it is explicitly requested
         *
         * u-show
         *
         * true: the modal is visible by default
         *
         *
         * closetext:
         *
         * You may add a class="sb.modal.closetext" to a tag in order to make the element a close tag
         *
         */
        super.createdCallback();


        const backdropType = this.getAttribute('u-backdrop');
        const staticBackdrop = (backdropType !== null && backdropType.toLowerCase() === 'static');

        this.backdrop = this.firstElementChild; // backdrop has to be the immediate child of u-modal

        // If we don't have a 'static' backdrop and we have a proper modal backdrop element, close when it's clicked
        if (!staticBackdrop && this.backdrop.className.indexOf('sb.modal.backdrop') >= 0) {
            this.backdrop.addEventListener('click', (evt) => {
                if (evt.target !== this.backdrop) { // but don't close if the modal window itself is clicked!
                    return;
                }
                this.$close();
            });
        }

        // if static, don't close the modal when the esc key is hit. overwrite inherited u.Openable functionality.
        if (staticBackdrop) {
            this._keyup = (evt) => {
                if (evt.keyCode === 27) {
                    // do nothing
                }
            };
        }

        const show = this.getAttribute('u-show');
        if (show !== null && (show.toLowerCase() === 'true' || show === '1')) {
            this.$open();
        }

        const closeText = this.querySelectorAll('.sb\\.modal\\.closetext');
        if(closeText.length > 0) {
            closeText[0].addEventListener('click', (evt) => {
                this.$close();
            });
        }
    }
};

u.Modal.register('u-modal');

u.ModalCookie = class extends u.Modal {

    createdCallback() {
        super.createdCallback();

        // look at cookie to see if cookie policy was already accepted. if not, display cookie policy modal.
        var cooky = readCookie('splunkbase_cookie_policy_accepted');
        if (!cooky) {
            this.$open();
        }
    }

    attachedCallback() {
        super.attachedCallback();

        // cookie policy modal accept button
        const acceptText = this.querySelectorAll('.sb\\.modal\\.accepttext');
        if(acceptText.length > 0) {
            acceptText[0].addEventListener('click', (evt) => {
                this.$close();

                // set cookie to expire one year from now
                const oneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                document.cookie = "splunkbase_cookie_policy_accepted=true; expires=" + oneYear.toUTCString() + "; path=/"

                document.dispatchEvent(new Event('u-modal-cookie-close'));

                // log cookie acceptance
                const xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v0/log/cookie_accept`);
                xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
                xhr.send();
            });
        }
    }
}
u.ModalCookie.register('u-modal-cookie');

u.ModalDDL = class extends u.Modal {
    createdCallback() {
        super.createdCallback();

        // override the click event in u.Openable
        this._click = (evt) => {
            // do nothing
        };
        
        // look at cookie to see if cookie policy was already accepted. if it was, open. if it wasn't, listen for u-modal-cookie-close
        var cooky = readCookie('splunkbase_cookie_policy_accepted');
        if (cooky) {
            this.$open();
        } else {
            // open the ddl modal when cookie modal is closed
            document.addEventListener('u-modal-cookie-close', (evt) => {
                this.$open();
            });
        }
    }

    attachedCallback() {
        super.attachedCallback();
        // DDL modal accept button
        const acceptText = this.querySelectorAll('.sb\\.modal\\.accepttext');
        if(acceptText.length > 0) {
            acceptText[0].addEventListener('click', (evt) => {
                this.$close();
            });
        }
    }
}
u.ModalDDL.register('u-modal-ddl');

u.ModalDeprecation = class extends u.Modal {
    createdCallback() {
        debugger;
        super.createdCallback();
        var cookie = readCookie("splunkbase_classic_deprecation_seen");
        var cooky = readCookie("splunkbase_cookie_policy_accepted");
        if (!cookie && cooky) {
            this.$open();
        }
    }

    attachedCallback() {
        super.attachedCallback();

        const setDeprecationCookie = () => {
            var cookie = readCookie("splunkbase_classic_deprecation_seen");
            if (!cookie) {
                const oneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                document.cookie = `splunkbase_classic_deprecation_seen=true; expires=${oneYear.toUTCString()}; path=/`
            }
            this.$close();
        };

        // Handle Cancel button - ensure cookie is set when clicked
        const cancelButton = this.querySelector('.sb\\.sb-modal\\.canceltext');
        if (cancelButton) {
            cancelButton.addEventListener('click', (evt) => {
                setDeprecationCookie();
            }, true); // Use capture phase
        }

        // Handle close button (X) - ensure cookie is set
        const closeButton = this.querySelector('.sb\\.sb-modal\\.closetext');
        if (closeButton) {
            closeButton.addEventListener('click', (evt) => {
                setDeprecationCookie();
            });
        }

        // Handle "Go to New Splunkbase" links - set cookie before navigation
        const goToNewSbLinks = this.querySelectorAll('.sb\\.new-sb-modal\\.redirect');
        goToNewSbLinks.forEach(link => {
            link.addEventListener('click', (evt) => {
                setDeprecationCookie();
            });
        });

        // Backup: Set cookie when modal closes for any reason
        this.addEventListener('u-modal-close', () => {
            setDeprecationCookie();
        });
    }
}
u.ModalDeprecation.register('u-modal-deprecation');

u.Drawer = class extends u.Openable {};
u.Drawer.register('u-drawer');

u.MobileSearch = class extends u.Openable {
    $open() {
        super.$open();
        document.body.style.overflowY = 'inherit';
    }
};
u.MobileSearch.register('u-mobile-search');

// js tool for reading cookie. hat tip: https://www.quirksmode.org/js/cookies.html
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}